<template>
  <div class="paymentSuccess">
    <Header />
    <div uk-height-viewport>
      <div class="uk-flex-center uk-width-auto uk-position-center">
        <img height="350" width="200" src="../assets/payment-success.png" />
        <p class="uk-heading-large uk-text-uppercase uk-text-bold">MERCI !</p>
        <p
          class="uk-text-uppercase uk-text-bold"
        >Nous vous remercions de votre confiance. Votre facture vous a été envoyé à l'adresse email indiquée.</p>
        <div class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center">
          <router-link :to="{ path: `/` }" replace>
            <button
              class="uk-button uk-button-primary uk-margin-top uk-animation-scale-up uk-border-rounded uk-text-bold"
            >RETOURNER À L'ACCUEIL</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";

export default {
  name: "paymentSuccess",
  components: {
    Header
  },
  mounted() {
    setTimeout(function() {
      window.location.href = "https://checkmy.house";
    }, 10000);
  },

  data() {
    return {};
  },

  methods: {}
};
</script>
